
@if (myServices?.length > 0) {
  <div class="my-service-container">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="title" translate>services.myServiceTitle</h1>
      <div class="d-flex align-items-center gap-1">
        @if (myVirtualCard) {
          <button class="btn btn-link title"
            [appHasAnyRole]="[AppRoles.customer]"
            (click)="openVirtualCardQrCode()"
            (keyup)="openVirtualCardQrCode()"
            title="{{ 'common.tooltip.displayQrCode' | translate }}">
            <fa-icon [icon]="icons.qrcode"></fa-icon>
          </button>
        }
        <button class="btn btn-link title"
          [appHasAnyPermission]="[PermissionKeys.gestionServices]"
          (click)="orderServices()"
          (keyup)="orderServices()"
          title="{{ 'common.sortable.title' | translate }}">
          <fa-icon [icon]="icons.sort"></fa-icon>
        </button>
      </div>
    </div>
    @for (service of myServices; track service) {
      <div class="d-flex justify-content-around my-service-row gap-3"
        [routerLink]="['/services/' + service.serviceId]">
        <div class="icon-container flex-shrink-0">
          <img class="icon" src="{{ buildIconUrl(service.serviceConfig.iconUrl, 'white') }}" alt="icon" height="60px"
            width="auto">
          </div>
          <div class="text-word-overflow-wrap flex-grow-1">
            <div class="d-flex flex-column justify-content-center h-100">
              <h3 translate>{{ service['name' + crtLang.toUpperCase()] }}</h3>
              <div class="d-flex flex-row">
                <fa-icon [icon]="icons.circle" class="circle" [ngStyle]="{ 'color': service.active ? 'green' : 'orange' }"></fa-icon>
                <h6 translate>{{ service.active ? 'services.view.available' : 'services.view.unavailable' }}</h6>
              </div>
            </div>
          </div>
          <!-- Next Booking / Subscription -->
          @if (service.nextEntry) {
            <div class="d-flex flex-column justify-content-center">
              <p class="bold m-0" translate>{{ service.nextEntry.entryType === MyServicesNextEntryType.Booking ? 'services.myNextBooking' : 'services.myNextSubscription' }}</p>
              <p class="bold m-0">{{ getNextEntryLabel(service.nextEntry) }}</p>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="content-container">
    <h1 translate>services.title</h1>

    <div class="btn-bar">
      @if (isLoggedIn) {
        <button class="btn btn-primary"
          [appHasAnyPermission]="[PermissionKeys.gestionServices]"
          (click)="createNewService(content)"
          translate>services.manage.createNew
        </button>
      }
    </div>

    <div class="row">
      @for (category of servicesByCategory; track category) {
        <div class="col-12 col-lg-6 col-xl-4">
          <div class="card">
            <div class="card-header">
              <img class="card-img-top" src="{{ category.imageUrl }}" alt="Card image cap">
              <h3 translate>{{ category['name' + crtLang.toUpperCase()]}}</h3>
            </div>
            @for (service of category.services; track service) {
              <div class="card-body" [routerLink]="['/services/' + service.serviceId]">
                <img class="service-icon" src="{{ buildIconUrl(service.iconUrl, 'dark_gray') }}" alt="icon">
                <h6 translate>{{ service['name' + crtLang.toUpperCase()] }}</h6>
              </div>
            }
          </div>
        </div>
      }

      @if (highlightedServices.length > 0) {
        <div class="col-12 col-lg-6 col-xl-4">
          <div class="card accordion" id="highlightedServices">
            <div class="card-header">
              <img class="card-img-top" src="{{ azureStorageAccountUrl + '/img/categories/highlight.jpg' }}" alt="Highlighted service card image">
              <h3>{{ 'services.highlightedServices' | translate }}</h3>
            </div>
            @for (highlightedService of highlightedServices; track highlightedService; let i = $index) {
              <div class="accordion-item">
                <div class="accordion-header">
                  <button class="accordion-button collapsed highlighted-service-background"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse' + i"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapse' + i">
                    <img class="service-icon" src="{{ buildIconUrl(highlightedService.iconURL, 'dark_gray') }}" alt="icon">
                    <h6>{{ highlightedService['name' + crtLang.toUpperCase()] }}</h6>
                  </button>
                </div>
                <div [id]="'collapse' + i" class="accordion-collapse collapse" data-bs-parent="#highlightedServices">
                  <div class="accordion-body">
                    {{ highlightedService['description' + crtLang.toUpperCase()] }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>


  <!-- Create service modal -->
  <ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title"  translate>services.chooseServiceTypeModal.title</h4>
      <button class="btn-close" aria-label="Close" (click)="d('Cross click')">

      </button>
    </div>
    <div class="modal-body">
      <div class="col-12">
        <label translate>services.chooseServiceTypeModal.chooseServiceType</label>
      </div>
      <div class="col-12">
        <select class="form-control form-select" name="serviceType" [(ngModel)]="serviceConfig">
          @for (configuredService of serviceConfigsMap; track configuredService) {
            <option
            [ngValue]="configuredService[1]">{{ configuredService[0] }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="c('cancel')" translate>
        common.no
      </button>
      <button type="button" class="btn btn-primary" (click)="c('confirm')" translate>
        common.yes
      </button>
    </div>
  </ng-template>
